import CommonVariables from "./variables";
import APIConnector from "./apiconnector";



export const WhereAmI = {
    SchoolSetup: 1,
    GradeWorksheet: 2,
    ProgramSchedule: 3,
    TallySheet: 4
};
//Common JS which can be accessed by any component and can decide the user navigation
const UserActivity = {
    SwitchUserNavigationBasedOnActivity: (userActivity) => {
        switch (userActivity.stage) {
            case WhereAmI.SchoolSetup:
                return '/externaldashboard/schoolinfo';
                break;
            case WhereAmI.GradeWorksheet:
                return '/externaldashboard/grades';
                break;
            case WhereAmI.ProgramSchedule:
                return '/externaldashboard/ProgramScheduleWizard';
                break;
            case WhereAmI.TallySheet:
                return '/externaldashboard/OrderEntryWizard';
                break;
            default:
                return '/externaldashboard';
        }
    },
    GetUserActivityDescription: (stage) => {
        switch (stage) {
            case WhereAmI.SchoolSetup:
                return 'School setup';
                break;
            case WhereAmI.GradeWorksheet:
                return 'Grade Worksheets';
                break;
            case WhereAmI.ProgramSchedule:
                return 'Program Schedule';
                break;
            case WhereAmI.TallySheet:
                return 'Tally sheet';
                break;
            default:
                return 'Completed';
        }
    },
};

export default UserActivity;
